import { forOwn, pickBy } from 'lodash-es';

export class BaseModel {

	constructor(data: any = {}) {
		const simpleFieldsData = pickBy(data, field => typeof field === 'number' ||
			typeof field === 'string' || typeof field === 'boolean'); // TODO: assign arrays with default values as well
		forOwn(simpleFieldsData, (value, key) => {
			this[key] = value;
			if (value === 'true' || value === 'false') {
				this[key] = value === 'true';
			}
 		});
	}
}
